import React, { useState } from 'react';
import { PostModel } from '../../NewsfeedModels';
import { Link } from 'react-router-dom';
import UserPostPicture from '../../UserPostPicture';
import { track } from 'shared/Tracking';
import UserProfilePopup from '../../UserProfile/UserProfilePopup/UserProfilePopup';
import UserProfileModal from '../../UserProfile/UserProfileModal/UserProfileModal';
import { useUserContext } from 'UserContext';

export default function Picture({ post }: { post: PostModel }) {
    const [openModal, setOpenModal] = useState(false);
    const { user } = useUserContext();
    const userValidation = post.user.id !== user?.id && post.user.role !== 'TANDEM';

    const navigateToUserProfile = () => {
        track('Posts: Navigate To User Profile', { post });
    };

    function handleOpenModal() {
        if (userValidation) {
            setOpenModal(true);
        }
    }

    return (
        <UserProfilePopup user={post.user}>
            {post.user.role === 'PROVIDER' ? (
                <Link to={`/provider/${post.user.id}`} onClick={navigateToUserProfile} style={{ zIndex: 99 }}>
                    <UserPostPicture profileImage={post.user.profile_picture ? post.user.profile_picture.image : ''} />
                </Link>
            ) : (
                <div onClick={handleOpenModal} style={{ cursor: userValidation ? 'pointer' : 'cursor' }}>
                    <UserPostPicture profileImage={post.user.profile_picture ? post.user.profile_picture.image : ''} />
                </div>
            )}
            <UserProfileModal open={openModal} user={post.user} onClose={() => setOpenModal(false)} />
        </UserProfilePopup>
    );
}
